import InfoForProductById from './infoForProductById';

export default InfoForProductById;